export default __webpack_public_path__ + "static/media/sports4.d2e545fb.jpg";